import React from "react";
import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import { useTranslation } from "react-i18next";

import { useStyles } from "./styles";

const GlobalParameter = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();

  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb
              title={t("SIDEBAR.GLOBAL_PARAMETERS")}
              iconPosition="end"
            />
          </Box>
        </Box>
    </Box>
  );
};

export default GlobalParameter;
